import { RumEvent } from "@datadog/browser-rum";

/** Function used to discard a RUM event before they are sent to Datadog.
 * Returns true if the event should be discarded, false if the event should be sent.
 * https://docs.datadoghq.com/real_user_monitoring/browser/modifying_data_and_context/?tab=npm#modify-the-content-of-a-rum-event
 */
export type DatadogEventFilter = (event: RumEvent) => boolean;

/** Add filters to this list to enable them. */
const eventFilters: DatadogEventFilter[] = [];

export const shouldDiscardEvent = (event: RumEvent): boolean => {
  return eventFilters.some((filter) => filter(event));
};
